var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mi"},[_c('div',{style:({ height: _vm.cheight + 'px', width: _vm.cwidth + 'px' }),attrs:{"id":"mi_map_container"}},[(_vm.sdMap[_vm.type])?_c('iframe',{staticClass:"model3d",style:({
        height: _vm.cwidth * 2 + 'px',
        width: _vm.cwidth + 'px',
        top: -(_vm.cwidth * 2 - _vm.cheight) / 2 + 'px',
      }),attrs:{"src":_vm.url3d,"frameborder":"0"}}):_c('el-amap',{attrs:{"zoom":_vm.zoom,"center":_vm.center,"amap-manager":_vm.amapManager,"events":_vm.events}})],1),_vm._v(" "),_c('button',{attrs:{"id":"mi_load_btn"},on:{"click":_vm.loadMap}},[_vm._v("加载")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ec973b1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/MapImage.vue
// module id = null
// module chunks = 